module.exports = __webpack_public_path__ + "img/timeobsessed.47bab2e5.jpg";